// Single Article JavaScript
// Handles functionality for individual article pages

document.addEventListener('DOMContentLoaded', function() {
  // Initialize components
  initializeTableOfContents();
  initializeSocialSharing();
  initializeNewsletterForms();
  initializeArticleEnhancements();
  initializeReadingProgress();
  initializeFloatingCta();
  trackArticleView();
});

// Table of Contents Generation
function initializeTableOfContents() {
  const tocContainer = document.querySelector('[data-toc]');
  if (!tocContainer) return;

  const articleBody = document.querySelector('.article-body');
  if (!articleBody) return;

  const headings = articleBody.querySelectorAll('h2');
  if (headings.length === 0) {
    tocContainer.style.display = 'none';
    return;
  }

  const tocNav = tocContainer.querySelector('.article-toc__nav');
  const tocList = document.createElement('ul');

  // Generate TOC from H2 headings
  headings.forEach((heading, index) => {
    // Add ID to heading if it doesn't have one
    if (!heading.id) {
      heading.id = `heading-${index + 1}`;
    }

    // Create TOC item
    const tocItem = document.createElement('li');
    const tocLink = document.createElement('a');
    tocLink.href = `#${heading.id}`;
    tocLink.textContent = heading.textContent;
    tocItem.appendChild(tocLink);
    tocList.appendChild(tocItem);
  });

  tocNav.appendChild(tocList);

  // Smooth scrolling for TOC links
  tocList.addEventListener('click', function(e) {
    if (e.target.tagName === 'A') {
      e.preventDefault();
      const targetId = e.target.getAttribute('href').slice(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        const headerOffset = 100;
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });

        // Track TOC click
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'article_toc_click',
            'toc_section': targetElement.textContent
          });
        }
      }
    }
  });

  // Highlight active section in TOC
  const observerOptions = {
    rootMargin: '-100px 0px -70% 0px',
    threshold: 0
  };

  const observerCallback = (entries) => {
    entries.forEach(entry => {
      const id = entry.target.id;
      const tocLink = tocNav.querySelector(`a[href="#${id}"]`);
      
      if (tocLink) {
        if (entry.isIntersecting) {
          // Remove active class from all links
          tocNav.querySelectorAll('a').forEach(link => {
            link.classList.remove('active');
          });
          // Add active class to current link
          tocLink.classList.add('active');
        }
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);
  headings.forEach(heading => observer.observe(heading));
}

// Social Sharing
function initializeSocialSharing() {
  const shareButtons = document.querySelectorAll('.article-share__button');
  
  shareButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const url = this.href;
      const network = this.className.split('--')[1];
      
      // Track share click
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'article_share',
          'share_network': network,
          'article_title': document.querySelector('.article-hero__title')?.textContent
        });
      }
      
      // Open share window
      if (network === 'email') {
        window.location.href = url;
      } else {
        window.open(url, 'share', 'width=600,height=400,toolbar=0,menubar=0');
      }
    });
  });

  // Native sharing API (if available)
  if (navigator.share) {
    const nativeShareButton = document.createElement('button');
    nativeShareButton.className = 'article-share__button article-share__button--native';
    nativeShareButton.innerHTML = '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path d="M15 13.5a3 3 0 11-2.217-2.895L8.699 8.114a3 3 0 110-4.228l4.084-2.491a3 3 0 11.434.71l-4.084 2.491a3.002 3.002 0 010 2.808l4.084 2.491A3 3 0 0115 13.5z"/></svg><span>Share</span>';
    
    nativeShareButton.addEventListener('click', async () => {
      try {
        await navigator.share({
          title: document.querySelector('.article-hero__title')?.textContent,
          text: document.querySelector('.article-hero__excerpt')?.textContent,
          url: window.location.href
        });
      } catch (err) {
        console.log('Native sharing failed:', err);
      }
    });
    
    // Add native share button to bottom share section
    const bottomShareButtons = document.querySelector('.article-share--bottom .article-share__buttons');
    if (bottomShareButtons) {
      bottomShareButtons.appendChild(nativeShareButton);
    }
  }
}

// Newsletter Forms
function initializeNewsletterForms() {
  const forms = document.querySelectorAll('[data-newsletter-form]');
  
  forms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();

      const emailInput = form.querySelector('input[type="email"]');
      const submitButton = form.querySelector('button[type="submit"]');
      const email = emailInput.value.trim();

      if (!email) return;

      // Disable form during submission
      emailInput.disabled = true;
      submitButton.disabled = true;
      const originalButtonText = submitButton.textContent;
      submitButton.textContent = 'Subscribing...';

      function showSuccess(message) {
        form.innerHTML = '<div class="newsletter-success">✓ ' + (message || 'Thank you for subscribing!') + '</div>';

        // Track subscription
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'newsletter_signup',
            'signup_location': 'article_page',
            'topic': window.uvceedBlogTopic || 'blog_subscriber'
          });
        }
      }

      function showError(message) {
        emailInput.disabled = false;
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;

        const errorMsg = document.createElement('div');
        errorMsg.className = 'newsletter-error';
        errorMsg.textContent = message || 'Something went wrong. Please try again.';
        form.appendChild(errorMsg);

        setTimeout(() => errorMsg.remove(), 5000);
      }

      // Subscribe through the shared Mailchimp integration, tagged with the
      // topic of the article being read so the right automation fires.
      subscribeBlogReader(email, showSuccess, showError);
    });
  });
}

/**
 * Send a blog reader to Mailchimp tagged with the topic they subscribed from.
 * window.uvceedBlogTopic is set by the 'mailchimp-blog-topic' snippet.
 */
function subscribeBlogReader(email, onSuccess, onError) {
  if (typeof window.subscribeToMailchimp !== 'function') {
    onError('Signup is temporarily unavailable. Please try again later.');
    return;
  }

  const source = window.uvceedBlogTopic || 'blog_subscriber';
  const topicLabel = window.uvceedBlogTopicLabel || '';

  window.subscribeToMailchimp(
    email,
    source,
    function() { onSuccess(); },
    function(err) {
      const text = String(err || '').replace(/<[^>]*>/g, '');
      // Mailchimp treats an existing address as an error; to the reader it is
      // the same outcome as a fresh signup.
      if (text.indexOf('already subscribed') > -1) {
        onSuccess("You're already on the list.");
      } else {
        onError(text || 'Something went wrong. Please try again.');
      }
    },
    topicLabel ? { topic: topicLabel } : null
  );
}

// Article Content Enhancements
function initializeArticleEnhancements() {
  const articleBody = document.querySelector('.article-body');
  if (!articleBody) return;

  // Wrap tables for responsive scrolling
  const tables = articleBody.querySelectorAll('table');
  tables.forEach(table => {
    const wrapper = document.createElement('div');
    wrapper.className = 'table-wrapper';
    table.parentNode.insertBefore(wrapper, table);
    wrapper.appendChild(table);

    // Label cells from header so rows can stack as cards on mobile
    const headers = [...table.querySelectorAll('thead th')].map(th => th.textContent.trim());
    if (headers.length < 3) return;
    table.querySelectorAll('tbody tr').forEach(row => {
      [...row.cells].forEach((cell, i) => {
        if (headers[i]) cell.setAttribute('data-label', headers[i]);
      });
    });
    wrapper.classList.add('table-wrapper--stacked');
  });

  // Add loading lazy to images; add fallback alt text to any image missing it
  const articleTitle = document.querySelector('.article-hero__title')?.textContent?.trim() || '';
  const images = articleBody.querySelectorAll('img');
  images.forEach(img => {
    if (!img.loading) {
      img.loading = 'lazy';
    }
    if (!img.getAttribute('alt')) {
      img.setAttribute('alt', articleTitle);
    }
  });

  // Enhance external links
  const links = articleBody.querySelectorAll('a[href^="http"]');
  links.forEach(link => {
    if (!link.hostname.includes('uvceed.com')) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });

  // Add click tracking to article links
  articleBody.addEventListener('click', function(e) {
    if (e.target.tagName === 'A') {
      const href = e.target.href;
      
      if (typeof window.dataLayer !== 'undefined') {
        window.dataLayer.push({
          'event': 'article_link_click',
          'link_url': href,
          'link_text': e.target.textContent
        });
      }
    }
  });
}

// Reading Progress Indicator
function initializeReadingProgress() {
  const progressBar = document.createElement('div');
  progressBar.className = 'reading-progress';
  document.body.appendChild(progressBar);

  const articleContent = document.querySelector('.article-content');
  if (!articleContent) return;

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const articleTop = articleContent.offsetTop;
    const articleHeight = articleContent.offsetHeight;
    const windowHeight = window.innerHeight;
    
    const progress = Math.max(0, Math.min(1, 
      (scrollTop - articleTop + windowHeight) / articleHeight
    ));
    
    progressBar.style.width = `${progress * 100}%`;
  });
}

// Track Article View
function trackArticleView() {
  // Track page view
  if (typeof window.dataLayer !== 'undefined') {
    const articleTitle = document.querySelector('.article-hero__title')?.textContent;
    const articleCategory = document.querySelector('.article-hero__category')?.textContent;
    const articleAuthor = document.querySelector('.article-hero__author-name')?.textContent;
    const readTime = document.querySelector('.article-hero__read-time')?.textContent;
    
    window.dataLayer.push({
      'event': 'page_view',
      'page_type': 'article',
      'article_title': articleTitle,
      'article_category': articleCategory,
      'article_author': articleAuthor,
      'article_read_time': readTime
    });
  }

  // Track scroll depth
  let scrollDepthTracked = {
    25: false,
    50: false,
    75: false,
    100: false
  };

  window.addEventListener('scroll', () => {
    const scrollPercent = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;
    
    Object.keys(scrollDepthTracked).forEach(depth => {
      if (scrollPercent >= parseInt(depth) && !scrollDepthTracked[depth]) {
        scrollDepthTracked[depth] = true;
        
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            'event': 'article_scroll_depth',
            'scroll_depth': depth + '%'
          });
        }
      }
    });
  });
}

// Floating Product CTA
function initializeFloatingCta() {
  const floatingCta = document.querySelector('[data-floating-cta]');
  if (!floatingCta) return;

  const card = floatingCta.querySelector('[data-floating-cta-card]');
  const closeBtn = floatingCta.querySelector('[data-floating-cta-close]');
  const trigger = floatingCta.querySelector('[data-floating-cta-trigger]');
  const mobileCard = floatingCta.querySelector('[data-floating-cta-mobile]');
  const mobileCloseBtn = floatingCta.querySelector('[data-floating-cta-mobile-close]');
  const articleContent = document.querySelector('.article-content');
  const footer = document.querySelector('footer, .footer, .site-footer');
  const ctaTopic = floatingCta.dataset.ctaTopic || 'none';
  let viewTracked = false;

  function track(event, params) {
    if (typeof window.dataLayer === 'undefined') return;
    window.dataLayer.push(Object.assign({ event: event, cta_topic: ctaTopic, page_type: 'article' }, params));
  }

  // Check if already dismissed this session
  if (sessionStorage.getItem('floatingCtaDismissed')) {
    floatingCta.classList.add('floating-cta--dismissed');
    return;
  }

  // Show CTA once the reader finishes the first section (second H2 enters the
  // viewport). Most paid-traffic readers leave before mid-article, so a 50%
  // threshold hid it from them. Articles with fewer than two H2s fall back to 50%.
  const showAnchor = document.querySelectorAll('.article-body h2')[1];

  function handleScroll() {
    if (!articleContent) return;

    let reached;
    if (showAnchor) {
      reached = showAnchor.getBoundingClientRect().top < window.innerHeight;
    } else {
      const scrollTop = window.scrollY;
      const articleTop = articleContent.offsetTop;
      const articleHeight = articleContent.offsetHeight;
      reached = (scrollTop - articleTop + window.innerHeight) / articleHeight >= 0.5;
    }

    if (reached) {
      floatingCta.classList.add('floating-cta--visible');

      // Impressions, so clicks and adds can be read as a rate
      if (!viewTracked) {
        viewTracked = true;
        track('floating_cta_view');
      }
    } else {
      floatingCta.classList.remove('floating-cta--visible');
    }

    // Hide when footer is visible
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      if (footerRect.top < window.innerHeight + 100) {
        floatingCta.classList.add('floating-cta--hidden');
      } else {
        floatingCta.classList.remove('floating-cta--hidden');
      }
    }
  }

  // Dismiss CTA
  function dismissCta() {
    floatingCta.classList.remove('floating-cta--visible');
    floatingCta.classList.add('floating-cta--dismissed');
    sessionStorage.setItem('floatingCtaDismissed', 'true');

    track('floating_cta_dismissed');
  }

  // Toggle mobile card
  function toggleMobileCard() {
    mobileCard.classList.toggle('floating-cta__mobile-card--open');

    // Track open
    if (mobileCard.classList.contains('floating-cta__mobile-card--open')) {
      track('floating_cta_expanded', { device: 'mobile' });
    }
  }

  // Close mobile card
  function closeMobileCard() {
    mobileCard.classList.remove('floating-cta__mobile-card--open');
  }

  // Event listeners
  window.addEventListener('scroll', handleScroll, { passive: true });

  if (closeBtn) {
    closeBtn.addEventListener('click', dismissCta);
  }

  if (trigger) {
    trigger.addEventListener('click', toggleMobileCard);
  }

  if (mobileCloseBtn) {
    mobileCloseBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeMobileCard();
    });
  }

  // Close mobile card when clicking outside
  document.addEventListener('click', function(e) {
    if (mobileCard && mobileCard.classList.contains('floating-cta__mobile-card--open')) {
      if (!mobileCard.contains(e.target) && !trigger.contains(e.target)) {
        closeMobileCard();
      }
    }
  });

  // Track CTA clicks
  floatingCta.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', function() {
      track('floating_cta_click', { link_url: this.href });
    });
  });

  // Track add to cart; cart-drawer.js handles the submit itself
  floatingCta.querySelectorAll('[data-floating-cta-form]').forEach(form => {
    form.addEventListener('submit', () => track('floating_cta_add_to_cart'));
  });

  // Initial check
  handleScroll();
}

// Add dynamic styles
const style = document.createElement('style');
style.textContent = `
  .reading-progress {
    position: fixed;
    top: 0;
    left: 0;
    height: 3px;
    background: linear-gradient(90deg, #03045E 0%, #023E8A 100%);
    width: 0;
    transition: width 0.1s ease;
    z-index: 9999;
  }
  
  .newsletter-success {
    color: #00C66B;
    font-weight: 600;
    text-align: center;
    padding: 20px;
    animation: fadeIn 0.3s ease;
  }
  
  .newsletter-error {
    color: #FF3B30;
    font-size: 14px;
    margin-top: 10px;
    animation: fadeIn 0.3s ease;
  }
  
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
document.head.appendChild(style);